import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  heading: `Give every customer the ‘personal finance’ experience`,
  description: `Deliver personalized experiences at scale using data that’s complete, trustworthy, and compliant.`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>

          <HeroRecipe.Form>
            <StyledDemoForm isProgressive={true} customFormIdentifier="site-industry-finserv-demo" />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image
              width="640"
              height="540"
              src={heroPng2x}
              alt="Illustration: Twilio Segment personal finance experience"
              loading="lazy"
            />
          </Picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledDemoForm = styled(DemoForm)`
  margin-top: 40px;
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 540px;
    padding-top: 80px;
  }
`

export default Hero
